// Contact.js
export default class Contact {
    constructor(data = {}) {
      this.id = data.id || null;
      this.invoiceId = data.invoiceId || null;
      this.name = data.name || null;
      this.orgUnit = data.orgUnit || null;
      this.emailAddress = data.emailAddress || null;
      this.phoneNo = data.phoneNo || null;
    }
  
    toJSON() {
      return {
        id: this.id,
        invoiceId: this.invoiceId,
        name: this.name,
        orgUnit: this.orgUnit,
        emailAddress: this.emailAddress,
        phoneNo: this.phoneNo
      };
    }
  }
  